export default "__VITE_ASSET___Wz5bQv3__"